import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { initLenis } from "@/lib/lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import WhyUs from "@/components/site/WhyUs";
import Products from "@/components/site/Products";
import Services from "@/components/site/Services";
import Promise from "@/components/site/Promise";
import Hercules from "@/components/site/Hercules";
import Reviews from "@/components/site/Reviews";
import LocationSection from "@/components/site/Location";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingCta from "@/components/site/FloatingCta";

function App() {
  useEffect(() => {
    initLenis();
  }, []);

  return (
    <div className="bg-ink font-body text-white">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <WhyUs />
        <Products />
        <Services />
        <Promise />
        <Hercules />
        <Reviews />
        <LocationSection />
        <Contact />
      </main>
      <Footer />
      <FloatingCta />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
